import React, {useEffect, useState} from 'react';
import { Form, Select, Divider, Checkbox } from 'antd';
import GenericDialog from '../../common/GenericDialog';
import axios, {prepareAxiosParamsForStruts} from "../../common/axios";
import {isFormMissingValues} from "../../common/utilityFunctions";

const { Option } = Select;

const ShareTestFamilyDialog = ({open, onClose, handleDialogOpen, testIds = [], testsName, testName, testFamilyId, testFamilyName = ''}) => {
    const [initialTeacherIds, setInitialTeacherIds] = useState([]),
        [teacherIds, setTeacherIds] = useState([]),
        [shareTeachers, setShareTeachers] = useState([]),
        [shareTestFamilyForm] = Form.useForm();

    let loadedInitialTeacherIds = false;

    useEffect(() => {
        if (!loadedInitialTeacherIds) {
            axios.get('/controlCentre/getSchoolsTeachers.action')
                .then(response => {
                    if (response.data) {
                        setShareTeachers(response.data);
                        const teacherIds = [];
                        response.data.forEach((teacher) => {
                            teacherIds.push(teacher.userId);
                        });
                        setInitialTeacherIds(teacherIds);
                        loadedInitialTeacherIds = true;
                    }
                }).catch((error) => {
                console.error('Error loading school\'s teachers: ', error);
            });
        }
    }, []);

    const onShareTestFamily = async () => {
        const fieldsValue = shareTestFamilyForm.getFieldsValue();

        if (isFormMissingValues(fieldsValue)) {
            shareTestFamilyForm.validateFields();
            return Promise.reject('Select at least one teacher.');
        } else {
            const params = {selectedTeachers: fieldsValue.teacherIds, testGroupId:testFamilyId};
            ShareTestFamily(params);
        }
    }

    const ShareTestFamily = (params) => {
        console.log('Share Test Family params: ',params);
        axios.post('/web/ui/test/shareTestGroup', params.selectedTeachers,{params:{testGroupId:params.testGroupId}}).then((response)=>{
            console.log('response.data: ',response.data);
            if (response.data && response.data.success) {
                displayToastMessage(`Test Family shared successfully`, response.data.message, 'success', 5000);
            }else{
                displayToastMessage(`Error sharing Test Family`, response.data.message, 'error', 5000);
                console.error('Error sharing Test Family');
            }
        }).catch((error)=>{
            console.error('Error sharing Test Family: ',error);
        }).finally(()=>{
            shareTestFamilyForm.resetFields();
            handleDialogOpen(false);
        })
    }

    const handleTeacherChange = value => {
        setTeacherIds(value);
    }

    const clearTeacherSelect = () => {
        shareTestFamilyForm.setFieldsValue({['teacherIds']: []});
        setTeacherIds([]);
    }

    const handleSelectAllTeacherIds = event => {
        if (event.target.checked) {
            setTeacherIds(initialTeacherIds);
            shareTestFamilyForm.setFieldsValue({['teacherIds']: initialTeacherIds});
        } else {
            clearTeacherSelect();
        }
    }


    return (
        <GenericDialog
            sx={{
                "& .MuiDialog-container": {
                    justifyContent: "center", // Align horizontally
                    alignItems: "flex-start", // Align to the top vertically
                },
                "& .MuiPaper-root": {
                    margin: 0, // Remove default margin
                    marginTop: '120px', // Add desired top margin
                }
            }}
            title={`Share Test Family (${testFamilyName}`}
            open={open}
            fullWidth={true}
            maxWidth={'xs'}
            onClose={() => {
                handleDialogOpen(false);
                shareTestFamilyForm.resetFields();
            }}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Share',
                    callback: onShareTestFamily,
                },
            ]}
        >
            <p style={{ maxWidth: '400px' }}>
                Select or search for a teacher's name to share the Test Family with them. Multiple teachers can be selected.
                The other teacher can then manage and assign the Test Family.
            </p>
            <Divider />
            <Form
                form={shareTestFamilyForm}
                // labelCol={{ span: 6 }}
            >
                <Form.Item
                    label="Teachers"
                    name="teacherIds"
                    rules={[
                        {
                            required: true,
                            message: 'Select at least one teacher.',
                        },
                    ]}
                >
                    <Select
                        style={{ width: '300px'}}
                        virtual={false}
                        showSearch={true}
                        popupRender={(menu) => (
                            <>
                                {menu}
                                <Divider style={{ margin: '0 0 4px 0' }} />
                                <div style={{ padding: '4px' }}>
                                    <Checkbox
                                        disabled={initialTeacherIds.length === 0}
                                        checked={initialTeacherIds.length === teacherIds.length}
                                        onChange={handleSelectAllTeacherIds}
                                    >
                                        Select all teachers
                                    </Checkbox>
                                </div>
                            </>
                        )}
                        allowClear
                        autoClearSearchValue={true}
                        onChange={handleTeacherChange}
                        mode="multiple"
                        maxTagCount="responsive"
                        filterOption={(input, option) =>
                            option.label?.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {shareTeachers?.map((teacher) => (
                            <Select.Option
                                key={teacher.userId}
                                value={teacher.userId}
                                label={`${teacher.firstName} ${teacher.lastName}`}
                            >
                                {teacher.firstName + ' ' + teacher.lastName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default ShareTestFamilyDialog;
